// extracted by mini-css-extract-plugin
export default {"page_head":"styles_page_head__F-n8Z"};